import { loadDynatraceRum } from './loadDynatraceRum'
import { markLoadPhase } from './loadPerformance'

loadDynatraceRum()
markLoadPhase('shell-bundle-loaded')

import { stripTrailingSlashFromPathname } from './shellLocation'

stripTrailingSlashFromPathname()

import './shell.css'
import { initializeShellDocumentTheme } from './shellDocumentTheme'

initializeShellDocumentTheme()

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { registerShellRoot } from './shellRoot'
import { UnifiedApp } from './UnifiedApp'

const el = document.getElementById('root')
if (!el) {
  throw new Error('root element missing')
}

const root = createRoot(el)
registerShellRoot(root)
root.render(
  <StrictMode>
    <UnifiedApp />
  </StrictMode>,
)
